module.exports = __webpack_public_path__ + "static/index/img/baikal-309.62cc7980.jpg";